const membershipStep = {
  title: "Membership confirmation",
  stepLabel: "STEP 5/5",
  subtitle:
    "To complete your program registration, select one of the membership options.",
  learnMoreText:
    "If you are not sure what to select, learn more about our membership options <a href='https://partners.adobe.com/digitalexperience/about' style='color: #1473E6; text-decoration: none;' target='_blank'>here</a>.",
  membershipOptions: [
    {
      value: "Silver",
      title: "Silver Membership",
      badge: "Prorated cost",
      badgeColor: "#E6E6E6",
      badgeTextColor: "#4B4B4B",
      description:
        "Reap the rewards of paid partnership with a Silver level membership that provides full access to the Partner Experience Hub and program, sandboxes for Adobe products, valuable enablement resources, and the ability to purchase add-on benefits. A $3,000 program fee applies.",
      asteriskMessage: "* Final fee may change based on time and local taxes.",
      benefits: [
        "Full access to the Partner Experience Hub including the Sales Center",
        "Leverage sandboxes and enablement resources",
        "Customize your benefits via the Benefits Center",
      ],
      viewAllLink: true,
      selectedMessage:
        "Your selection includes fees. Proceed to checkout and make payment to complete your registration.",
    },
    {
      value: "Community",
      title: "Community Membership",
      badge: "Free",
      badgeColor: "#E6E6E6",
      badgeTextColor: "#4B4B4B",
      description:
        "Get a taste of the benefits of partnering with Adobe with this entry-level, free membership that offers limited access to the Partner Experience Hub and program, and foundational enablement resources. No program fee required.",
      benefits: [
        "Limited access to the Partner Experience Hub",
        "Entry-level access to foundational enablement resources",
        "Ability to upgrade to the Silver membership anytime",
      ],
      viewAllLink: true,
      selectedMessage:
        "You selected an option with no fee attached. Click Register to complete your application.",
    },
  ],
} as const;

export type MembershipStepContent = typeof membershipStep;
export default membershipStep;
